import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import {Alert, Card, Col, Form, Row} from "antd";
import qs from "qs";
import {unsubscribeEmail} from "../actions/unsubscribe";
import {Loading} from "../libs/loading";

class EmailUnsubscribe extends React.Component  {
    state = {
        loading: true,
        success: false
    }

    componentDidMount() {
        const q = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

        this.props.unsubscribeEmail(q.eid, () => {
            this.setState({ loading: false, success: true});
        }, () => {
            this.setState({ loading: false, success: false});
        });
    }

    render() {
        let content;

        if(this.state.loading) {
            content = <div className='text-center'><Loading/></div>;
        } else {
            if(this.state.success) {
                content = <Alert type='success' showIcon message='You have been successfully unsubscribed!' />;
            } else {
                content = <Alert type='error' showIcon message='Something went wrong, please contact our support.' />
            }
        }

        return(
            <div className='auth-wrapper'>
                <Card className='form-container login'>
                    <div className='logo-container'>
                        <img alt='Priority Prospect' src='/img/logo-top-dark.png' />
                    </div>

                    <Form layout='vertical'>
                        <Fragment>
                            <Row>
                                <Col span={24}>
                                    {content}
                                </Col>
                            </Row>
                        </Fragment>
                    </Form>
                </Card>
            </div>
        );
    }
}

export default connect(null, { unsubscribeEmail })(EmailUnsubscribe);